

import { CartDetails, UserType } from 'src/redux/cart/types'
import { CreateOrderRequestBody, UpdateCustomerRequestBody } from 'src/types/types'
import { transformFilters } from 'src/utils/filters'
import { WcParams, WcQueryParams } from './types'

export const createWCQueryParams = (queryParams: WcQueryParams): WcParams => {
  const { filters, order, orderBy, page, perPage, searchTerm } = queryParams
  const transformedFilters = transformFilters(filters)

  return {
    order,
    orderby: orderBy,
    page,
    per_page: perPage,
    search: searchTerm,
    ...transformedFilters,
  }
}

export const mapCartDetailsToOrderRequest = (cartDetails: CartDetails): CreateOrderRequestBody => {
  
  console.log('cart details:', cartDetails)

  return {
    payment_method: 'kco',
    payment_method_title: '',
    set_paid: false,
    billing: cartDetails.billing_address,
    shipping: cartDetails.shipping_address,
    line_items: [],
    shipping_lines: [],
    customer_note: cartDetails.additionalInfo,
  }
}

export const mapCartDetailsToUpdateCustomerRequest = (
  cartDetails: CartDetails
): UpdateCustomerRequestBody => {
  const userAddress = cartDetails[UserType.Receiver]
  const {
    streetAddress,
    postalAddress: { postal_code, municipality_name },
  } = userAddress

  return {
    billing_address: {
      first_name: cartDetails.firstName,
      last_name: cartDetails.lastName,
      company: '',
      address_1: streetAddress,
      address_2: '',
      city: municipality_name,
      state: '',
      postcode: postal_code,
      country: 'FI',
      email: cartDetails.email,
      phone: cartDetails.phoneNumber,
    },
    shipping_address: {
      first_name: cartDetails.firstName,
      last_name: cartDetails.lastName,
      company: '',
      address_1: streetAddress,
      address_2: '',
      city: municipality_name,
      state: '',
      postcode: postal_code,
      country: 'FI',
      phone: cartDetails.phoneNumber,
      email: cartDetails.email,
    },
  }
}
